import { normalizeBase, mergeBases, isRouteLocationNameObject, isRouteLocationByResolver, joinPath, removeBase, normalizeLocation, isPathsEqual, convertSearchToQuery } from "@constructor/federation-common/base";
import { convertQueryToSearch, navigateRouter, getRelativePathname, convertRouterLocationToFederation } from "@constructor/federation-common/react";
import { isDeepEqual, pick } from "@constructor/services";
function createFederationRouterFabric({
  router,
  resolver
}) {
  return {
    createFederationRouter
  };
  function createFederationRouter(options) {
    const base = normalizeBase(options == null ? void 0 : options.base);
    const fullBase = mergeBases(router.basename, base);
    return {
      go,
      getCurrentRoute,
      push,
      afterEach,
      base: fullBase,
      isActive,
      resolve
    };
    function resolve(to) {
      const stripBase = !isRouteLocationNameObject(to) && !isRouteLocationByResolver(to);
      const resolved = resolveLocation(to);
      const href = joinPath(router.basename ?? "/", resolved.fullPath);
      if (stripBase) {
        resolved.path = removeBase(resolved.path, base);
        resolved.fullPath = removeBase(resolved.fullPath, base);
      }
      return { ...resolved, href };
    }
    function isActive(to) {
      console.warn("isActive() is not implemented in React parent router yet");
      return false;
    }
    function resolveLocation(to) {
      const location = normalizeLocationStrict(to);
      const search = convertQueryToSearch(location.query);
      return {
        path: location.path,
        fullPath: location.path + (search.size ? `?${search.toString()}` : ""),
        hash: location.hash ?? "",
        query: Object.fromEntries(search.entries())
      };
    }
    function normalizeLocationStrict(to) {
      const result = normalizeLocation(to, { base, resolver });
      if ("name" in result) {
        throw new Error(
          `Resolving route to name is not supported in React parent router(${result.name}). Configure "resolver" option in federation root router config`
        );
      }
      return result;
    }
    function go(delta) {
      router.navigate(delta);
    }
    function afterEach(fn) {
      let subscribed = true;
      const unsubscribe = router.subscribe(({ location }) => {
        setTimeout(() => {
          if (!subscribed) {
            return;
          }
          fn(toFederationRoute(location));
        }, 0);
      });
      return () => {
        unsubscribe();
        subscribed = false;
      };
    }
    async function push(newTo) {
      if ((isRouteLocationNameObject(newTo) || isRouteLocationByResolver(newTo)) && !resolver) {
        throw new Error(
          `Fragment try to navigate to "${JSON.stringify(newTo)}" but "resolver" in parent router is not set`
        );
      }
      const to = normalizeLocationStrict(newTo);
      const currentRoute = router.state.location;
      if (isPathsEqual(to.path ?? "", currentRoute.pathname) && isDeepEqual(to.query ?? {}, convertSearchToQuery(currentRoute.search)) && !to.force) {
        return;
      }
      await navigateRouter(router, to);
    }
    function getCurrentRoute() {
      return toFederationRoute(router.state.location);
    }
    function toFederationRoute(to, stripBase = true) {
      const route = pick(to, ["hash", "pathname", "search"]);
      if (stripBase) {
        const relativePathname = getRelativePathname(router, route.pathname);
        if (!relativePathname.startsWith(base)) {
          throw new Error(
            `Fragment can't access route "${relativePathname}" because it's outside of base "${base}"`
          );
        }
        route.pathname = removeBase(relativePathname, base);
      }
      return convertRouterLocationToFederation(route);
    }
  }
}
export {
  createFederationRouterFabric as c
};
//# sourceMappingURL=router.js.map
